import React from 'react';
import { Icon } from './Icon.js';
export const IconChartHistogram = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M3 16H6L8.5 10.5H10L12.5 5L14.5 5C16.4526 9.29577 17.5474 11.7042 19.5 16H21", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M3 3V21H21", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconChartHistogram.js.map